import React from 'react';

const TONE_CLASSES = {
  light: 'bg-white border border-slate-200 shadow-sm',
  dark: 'bg-slate-900 border border-slate-800',
};

const Card = ({ tone = 'light', padding = 'p-6', className = '', children, ...rest }) => (
  <div
    className={['rounded-xl', TONE_CLASSES[tone], padding, className].join(' ')}
    {...rest}
  >
    {children}
  </div>
);

export default Card;
